module.exports = __webpack_public_path__ + "static/mitch.ea9bcfaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/bios/img/mitch.png
// module id = 234
// module chunks = 35783957827783 107818501498521